import React from 'react';
import { amountFormatter, summaryTableMessages } from 'azshared';
import './summary-table.scss';
import { useIntl } from 'react-intl';
import { PirBoxProductSummary } from 'azshared/build/main/lib/model/pirbox/pirbox-product-summary';
import { PirBoxSummaryTablePosition } from './summary-table-position';

export interface SummeryTableProps {
  summary: PirBoxProductSummary;
  expirationDate: Date;
}

export const SummaryTable = (props: SummeryTableProps) => {
  const { summary, expirationDate } = props;
  const { formatMessage } = useIntl();

  const isExpirationDateDefined = expirationDate !== undefined;
  const isExpired = isExpirationDateDefined && expirationDate < new Date(Date.now());
  const positions = summary?.productsDetails;

  return (
    <div className='table-summary'>
      <div className='header-section'>
        <div>
          <p className='cell-weight'>
            {formatMessage(summaryTableMessages.maxAmountInvestibleCurrentYear)}
            <sup>3</sup>
          </p>
          <p>{amountFormatter(summary?.maxAnnualInvestable)}</p>
        </div>
        <div>
          <p className='cell-weight'>
            {formatMessage(summaryTableMessages.remainingInvestableCurrentYear)}
            <sup>4</sup>
          </p>
          <p>{amountFormatter(summary?.annualInvestableResidue)}</p>
        </div>
      </div>
      {positions
        .filter((position) => position.positions?.length)
        .map((position) => position && <PirBoxSummaryTablePosition key={position?.typology} expirationDate={expirationDate} position={position} />)}
      <div>
        <div>
          <p>{formatMessage(summaryTableMessages.disclaimer3)}</p>
          <p>{formatMessage(summaryTableMessages.disclaimer4)}</p>
          <p>{formatMessage(summaryTableMessages.disclaimer5)}</p>
          <p>{formatMessage(summaryTableMessages.disclaimer6)}</p>
          <p>{isExpirationDateDefined && isExpired && formatMessage(summaryTableMessages.disclaimer7)}</p>
        </div>
      </div>
    </div>
  );
};
